import * as React from 'react'
import styled from '@emotion/styled'
import { Button } from 'antd'

export const ButtonLoader = ({ loading, ...props }: any) => (
  <Wrapper>
    <Button loading={loading} disabled={loading} {...props}>
      {props.children}
    </Button>
  </Wrapper>
)

const Wrapper = styled.div`
  position: relative;
`
